import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { MenuItem, FormControl, Select } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useForm, Controller } from 'react-hook-form';
import dayjs from 'dayjs';

import { useTranslation } from 'react-i18next';


function SearchPayHistory({ search, setSearch, handleResetForm }) {
  const payMedthodList = [
  { value: 'e-BillPayment' },
  { value: 'E-Invoice' },
  { value: 'Credit Card' },
  { value: 'Internet Banking' },
];

const { t } = useTranslation();
  const { register, handleSubmit, control, reset } = useForm();
  const [payMethod, setPayMethod] = useState('');

  const submit = (value) => {
    // console.log('value', value);
    setSearch({
      maxPayAmount: value.maxPayAmount,
      minPayAmount: value.minPayAmount,
      payment_method: value.payment_method,
      service: value.service,
      startDate: value.startDate || dayjs().startOf('year'),
      endDate: value.endDate || dayjs(),
      tran_ref: value.tran_ref,
    });
  };

  return (
    <div className="">
      <form onSubmit={handleSubmit(submit)}>
        {/* Grid Container สำหรับ Row 1 และ 2 
          grid-cols-1: บนมือถือจะเป็น 1 คอลัมน์ (เรียงลงมา)
          lg:grid-cols-3: บนหน้าจอใหญ่ (1024px ขึ้นไป) จะเป็น 3 คอลัมน์ 
          gap-4: ระยะห่างระหว่างช่อง
        */}

        {/* === First Row (Transaction Ref No. และ Payment Date) === */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full">
          {/* ช่องที่ 1: Transaction Ref No. */}
          <div className="lg:col-span-1">
            <div className="mb-1">{t('app.transactionRefNo')}</div>
            <TextField
              {...register('tran_ref')}
              id="outlined-basic-tran-ref"
              size="small"
              sx={{ width: '100%', backgroundColor: '#FFFFFF' }}
            />
          </div>

          {/* ช่องที่ 2 & 3: Payment Date Range 
              lg:col-span-2: ช่องนี้จะกินพื้นที่ 2 คอลัมน์จาก 3 (เพื่อให้เต็มแถว) 
            */}
          <div className="lg:col-span-2">
            <div className="mb-1">{t('app.paymentDate')}</div>
            {/* ใช้ Flexbox จัดการ Date Picker ภายในช่อง 2 คอลัมน์นี้ */}
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2 items-center">
              {/* Start Date: ให้ยืดเต็ม w-full และใช้ flex-1 บน md */}
              <div className="w-full md:flex-1">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Controller
                    control={control}
                    name="startDate"
                    render={({ field }) => (
                      <DatePicker
                        sx={{ width: '100%', backgroundColor: '#fff' }}
                        slotProps={{ textField: { size: 'small' } }}
                        format="DD/MM/YYYY"
                        value={search.startDate}
                        views={['year', 'month', 'day']}
                        onChange={(e) => field.onChange(e)}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>

              <div className="text-center text-xl md:w-auto"> - </div>

              {/* End Date: ให้ยืดเต็ม w-full และใช้ flex-1 บน md */}
              <div className="w-full md:flex-1">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Controller
                    control={control}
                    name="endDate"
                    render={({ field }) => (
                      <DatePicker
                        format="DD/MM/YYYY"
                        sx={{ width: '100%', backgroundColor: '#fff' }}
                        slotProps={{ textField: { size: 'small' } }}
                        views={['year', 'month', 'day']}
                        onChange={(e) => field.onChange(e)}
                        value={search.endDate}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </div>
          </div>
        </div>

        {/* === Second Row (Service Name และ Pay Amount) === */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full mt-4">
          {' '}
          {/* เพิ่ม mt-4 เป็นระยะห่างระหว่างแถว */}
          {/* ช่องที่ 1: Service Name */}
          <div className="lg:col-span-1">
             <div className="mb-1">{t('app.serviceName')}</div>
            <TextField
              {...register('service')}
              id="outlined-basic-service"
              size="small"
              sx={{ width: '100%', backgroundColor: '#FFFFFF' }}
            />
          </div>
          {/* ช่องที่ 2 & 3: Pay Amount Range 
              lg:col-span-2: ช่องนี้จะกินพื้นที่ 2 คอลัมน์จาก 3
            */}
          <div className="lg:col-span-2">
            <div className="mb-1">
                 <div className="mb-1">{t('app.payAmount')}</div>
            </div>
            {/* ใช้ Flexbox จัดการ Min/Max Amount ภายในช่อง 2 คอลัมน์นี้ */}
            <div className="flex w-full gap-2 items-center">
              {/* Min Amount: ใช้ flex-1 เพื่อให้ยืดเต็มที่ */}
              <TextField
                {...register('minPayAmount')}
                sx={{ width: '100%', backgroundColor: '#fff' }}
                size="small"
                id="outlined-size-small-min"
                type="number"
                placeholder="THB"
                className="flex-1"
              />

              <div className="text-center text-xl"> - </div>

              {/* Max Amount: ใช้ flex-1 เพื่อให้ยืดเต็มที่ */}
              <TextField
                {...register('maxPayAmount')}
                sx={{ width: '100%', backgroundColor: '#fff' }}
                size="small"
                id="outlined-size-small-max"
                type="number"
                placeholder="THB"
                className="flex-1"
              />
            </div>
          </div>
        </div>

        {/* === Third Row (Payment Method) === */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full mt-4">
          {/* ช่องที่ 1: Payment Method - กิน 1 คอลัมน์จาก 3 */}
          <div className="lg:col-span-1">
            <div className="mb-1">
              <div className="mb-1">{t('app.paymentMethod')}</div>
            </div>

            <Controller
              name="payment_method"
              control={control}
              render={({ field }) => (
                <Select
                  size="small"
                  value={payMethod}
                  sx={{ width: '100%', backgroundColor: '#FFFFFF' }}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setPayMethod(e.target.value);
                  }}
                >
                  {payMedthodList.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.value}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </div>
          {/* ช่องที่ 2 และ 3 ที่เหลือใน Grid (ว่างไว้) 
              ถ้าต้องการให้มันวางถัดจากแถวนี้ทันทีก็ทำได้เลย
            */}
        </div>

        {/* Buttons - จัดให้อยู่ทางขวาเสมอ และเรียงเป็นคอลัมน์บนมือถือ */}
        <div className="flex flex-col lg:flex-row mt-5 justify-end gap-2">
          <Button type="submit" variant="outlined" color="lightGreen">
          <div className="mb-1">{t('app.search')}</div>
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => {
              reset({
                startDate: dayjs().startOf('year'),
                endDate: dayjs(),
                service: '',
                minPayAmount: '',
                maxPayAmount: '',
                payment_method: '',
                tran_ref: '',
              });
              setPayMethod('');
              handleResetForm();
            }}
          >
        <div className="mb-1">{t('app.clear')}</div>
          </Button>
        </div>
      </form>
    </div>
  );
}

export default SearchPayHistory;
